var render = function render(){var _vm=this,_c=_vm._self._c;return (Boolean(_vm.selected))?_c('vs-col',{staticClass:"reset-alert-height"},[_c('vs-alert',{attrs:{"active":Boolean(_vm.selected),"title":"OFERTA SELECIONADA","color":"dark"}},[_c('span',{staticStyle:{"font-size":"1.15em"}},[_vm._v(_vm._s(_vm.selected.FILIALCAMPUS)+" ("+_vm._s(_vm.selected.CIDADE)+") - "+_vm._s(_vm.modalidade))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }